"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryTooltip", {
  enumerable: true,
  get: function () {
    return _victoryTooltip.default;
  }
});
Object.defineProperty(exports, "Flyout", {
  enumerable: true,
  get: function () {
    return _flyout.default;
  }
});

var _victoryTooltip = _interopRequireDefault(require("./victory-tooltip"));

var _flyout = _interopRequireDefault(require("./flyout"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-tooltip/lib/index.js
// module id = 690
// module chunks = 0